import { render, staticRenderFns } from "./CreationOutline.vue?vue&type=template&id=887ca460"
import script from "./CreationOutline.vue?vue&type=script&lang=js"
export * from "./CreationOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports